import { render } from "./Table.vue?vue&type=template&id=75143b76&ts=true"
import script from "@/composables/pages/master-setting/passenger-type/TableComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/pages/master-setting/passenger-type/TableComposable.ts?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=75143b76&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__